module.exports = __webpack_public_path__ + "img/9788958283508.b074348a.jpg";